export const copyVideoSection = {
  title:
    "Imagine a world where your developers spend less time waiting on builds and tests to complete or dealing with failures. Let's make that a reality.",
  button: 'Watch the 2-min explainer',
  videoLink: 'https://gradleinc.wistia.com/medias/3ikit0em21',
  backgroundVideo: [
    {
      src: '/assets/videos/IMAGINE_VIDEO-BG(desktop).mp4',
      className: 'w-full hidden md:flex',
    },
    {
      src: '/assets/videos/IMAGINE_VIDEO-BG(mobile).mp4',
      className: `w-full flex md:hidden`,
    },
  ],
};
